'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = exports.CarouselNext = exports.CarouselPrev = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselPrev = exports.CarouselPrev = function (_Component) {
  (0, _inherits3.default)(CarouselPrev, _Component);

  function CarouselPrev() {
    (0, _classCallCheck3.default)(this, CarouselPrev);
    return (0, _possibleConstructorReturn3.default)(this, (CarouselPrev.__proto__ || (0, _getPrototypeOf2.default)(CarouselPrev)).apply(this, arguments));
  }

  (0, _createClass3.default)(CarouselPrev, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.props.currentSlide === 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentSlide = _props.currentSlide,
          previousSlide = _props.previousSlide;


      return _react2.default.createElement(
        'a',
        {
          className: (0, _classnames2.default)('carousel__localnav carousel__localnav--prev', {
            'carousel__localnav--disabled': currentSlide === 0
          }),
          onClick: previousSlide
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'carousel.prev',
          defaultMessage: 'Previous'
        }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'svg', uniquifyIDs: false, src: require('../../../static/img/arrow.svg') })
      );
    }
  }]);
  return CarouselPrev;
}(_react.Component);

CarouselPrev.propTypes = {
  currentSlide: _propTypes2.default.number.isRequired,
  previousSlide: _propTypes2.default.func.isRequired
};

// eslint-disable-next-line react/no-multi-comp

var CarouselNext = exports.CarouselNext = function (_Component2) {
  (0, _inherits3.default)(CarouselNext, _Component2);

  function CarouselNext() {
    (0, _classCallCheck3.default)(this, CarouselNext);
    return (0, _possibleConstructorReturn3.default)(this, (CarouselNext.__proto__ || (0, _getPrototypeOf2.default)(CarouselNext)).apply(this, arguments));
  }

  (0, _createClass3.default)(CarouselNext, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      var _props2 = this.props,
          slidesToScroll = _props2.slidesToScroll,
          slideCount = _props2.slideCount,
          currentSlide = _props2.currentSlide;


      return slidesToScroll >= slideCount - currentSlide;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          slidesToScroll = _props3.slidesToScroll,
          slideCount = _props3.slideCount,
          currentSlide = _props3.currentSlide,
          nextSlide = _props3.nextSlide;


      return _react2.default.createElement(
        'a',
        {
          className: (0, _classnames2.default)('carousel__localnav carousel__localnav--next', {
            'carousel__localnav--disabled': slidesToScroll >= slideCount - currentSlide
          }),
          onClick: nextSlide
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'carousel.next',
          defaultMessage: 'Next'
        }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'svg', uniquifyIDs: false, src: require('../../../static/img/arrow.svg') })
      );
    }
  }]);
  return CarouselNext;
}(_react.Component);

CarouselNext.propTypes = {
  currentSlide: _propTypes2.default.number.isRequired,
  slideCount: _propTypes2.default.number.isRequired,
  nextSlide: _propTypes2.default.func.isRequired,
  slidesToScroll: _propTypes2.default.number.isRequired
};

// eslint-disable-next-line react/no-multi-comp

var Pagination = exports.Pagination = function (_Component3) {
  (0, _inherits3.default)(Pagination, _Component3);

  function Pagination() {
    (0, _classCallCheck3.default)(this, Pagination);
    return (0, _possibleConstructorReturn3.default)(this, (Pagination.__proto__ || (0, _getPrototypeOf2.default)(Pagination)).apply(this, arguments));
  }

  (0, _createClass3.default)(Pagination, [{
    key: 'getIndexes',
    value: function getIndexes(count, inc) {
      var arr = [];
      for (var page = 0; page < count; page += inc) {
        arr.push(page);
      }
      return arr;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          slideCount = _props4.slideCount,
          slidesToScroll = _props4.slidesToScroll,
          currentSlide = _props4.currentSlide,
          goToSlide = _props4.goToSlide;


      var indexes = this.getIndexes(slideCount, slidesToScroll);
      return _react2.default.createElement(
        'ul',
        { className: 'carousel__pagination' },
        indexes.map(function (index) {
          return _react2.default.createElement(
            'li',
            {
              key: index,
              className: (0, _classnames2.default)('carousel__pagination__page', {
                selected: currentSlide === index
              })
            },
            _react2.default.createElement(
              'a',
              { onClick: goToSlide.bind(null, index) },
              index
            )
          );
        })
      );
    }
  }]);
  return Pagination;
}(_react.Component);

Pagination.propTypes = {
  slidesToScroll: _propTypes2.default.number.isRequired,
  slideCount: _propTypes2.default.number.isRequired,
  currentSlide: _propTypes2.default.number.isRequired,
  goToSlide: _propTypes2.default.func.isRequired
};